// Contas e formatação da tela de Caixa. A regra de verdade da conferência é a
// do servidor (backend/api/v1/caixa/conferencia.py); aqui só o que a tela mostra
// ao vivo enquanto o caixa está aberto.

export const AUTOMATICAS = ["PIX Online", "Cartão Online", "iFood"];
/** Vendas sem a forma real gravada — não dá para contar "Múltiplo" na gaveta. */
export const SEM_FORMA = ["Múltiplo", "Pagar na Retirada", "Não informado"];

/** Contagem com ponto de milhar (1.437), igual ao dinheiro. */
export const inteiro = (v) => (Number(v) || 0).toLocaleString("pt-BR");
export const reais = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const hora = (iso) => (iso ? new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "");
/** created_at/opened_at são gravados com -03:00: os 10 primeiros caracteres já são o dia local. */
export const diaLocal = (iso) => (iso ? String(iso).slice(0, 10) : "");
export const dataBR = (iso) => (iso ? diaLocal(iso).split("-").reverse().join("/") : "—");

const soma = (lista, fn) => (lista || []).reduce((s, x) => s + (Number(fn(x)) || 0), 0);
const outro = (resumo, tipo) => soma((resumo?.outros || []).filter((o) => o.tipo === tipo), (o) => o.total);

/** Dinheiro que deveria estar na gaveta agora: abertura + vendas em dinheiro + suprimentos − sangrias. */
export function gaveta(caixa, resumo) {
  const dinheiro = soma((resumo?.vendas_por_pagamento || []).filter((v) => v.forma_pagamento === "Dinheiro"), (v) => v.total);
  return (Number(caixa?.valor_abertura) || 0) + dinheiro + outro(resumo, "adicao") - outro(resumo, "sangria");
}

export const totalVendido = (resumo) => soma(resumo?.vendas_por_pagamento, (v) => v.total);
export const sangrias = (resumo) => outro(resumo, "sangria");
export const suprimentos = (resumo) => outro(resumo, "adicao");

/** "3h12" desde a abertura. */
export function tempoAberto(iso, agora = new Date()) {
  if (!iso) return "";
  const min = Math.max(0, Math.round((agora - new Date(iso)) / 60000));
  const h = Math.floor(min / 60);
  if (h >= 48) return `${Math.floor(h / 24)} dias`;
  return h ? `${h}h${String(min % 60).padStart(2, "0")}` : `${min} min`;
}

/** Caixa esquecido: aberto em outro dia ou há mais de 14 horas. */
export function alertaEsquecido(caixa, agora = new Date()) {
  if (!caixa?.opened_at) return null;
  const hojeLocal = `${agora.getFullYear()}-${String(agora.getMonth() + 1).padStart(2, "0")}-${String(agora.getDate()).padStart(2, "0")}`;
  if (diaLocal(caixa.opened_at) < hojeLocal) return `Este caixa está aberto desde ${dataBR(caixa.opened_at)} às ${hora(caixa.opened_at)}. Feche e abra um novo para o movimento de hoje não se misturar com o de ontem.`;
  const horas = (agora - new Date(caixa.opened_at)) / 3600000;
  return horas > 14 ? `Caixa aberto há ${tempoAberto(caixa.opened_at, agora)}. Confira se não esqueceram de fechar o turno anterior.` : null;
}

/** Conferência gravada no caixa (lista) → formato que o cupom lê. */
export function paraCupom(caixa) {
  let lista = caixa?.conferencia_detalhe || caixa?.conferencia;
  if (typeof lista === "string") { try { lista = JSON.parse(lista); } catch (_) { lista = null; } }
  if (!Array.isArray(lista)) return caixa;
  return { ...caixa, conferencia_detalhe: lista, conferencia: Object.fromEntries(lista.map((f) => [f.forma, f.contado])) };
}
